module.exports = __webpack_public_path__ + "img/four1Orange.9054a3e8.jpg";